<template>
  <b-button
    v-if="isVisible()"
    type="button"
    variant="success"
    @click="promiseButtonClicked = handleClick()"
    v-busy-button="promiseButtonClicked"
    :disabled="isDisabled()">
    <icon class="btn-icon" :name="buttonIcon"></icon>
    {{ buttonText }}
  </b-button>
</template>

<script>
  import enums from '@/common/enums'
  import eventBus from '@/services/event-bus/event-bus'
  import channelService from '@/services/amio-api/channel.service'
  import 'vue-awesome/icons/rocket'

  const agentStates = enums.platforms.rbm.agentStates
  const regions = enums.platforms.rbm.regions

  export default {
    props: {
      agentState: {
        type: String,
        required: true
      },
      channel: {
        type: Object,
        required: true
      },
      modalIdCreateAgent: {
        type: String,
        required: true
      }
    },

    computed: {
      buttonText() {
        const agentState = this.channel.rbm.agent_state

        if (agentState === agentStates.new) return 'Register Agent'
        if (agentState === agentStates.createRequested) return 'Launch Agent'
        if (agentState === agentStates.created) return 'Launch Agent'
      },

      buttonIcon() {
        const agentState = this.channel.rbm.agent_state
        const {createRequested, created} = agentStates
        if ([createRequested, created].includes(agentState)) {
          return 'rocket'
        }

        return 'plus-circle'
      }
    },

    data() {
      return {
        promiseButtonClicked: null,
        regions
      }
    },

    methods: {
      isDisabled() {
        const agentState = this.channel.rbm.agent_state
        const {createRequested, launchRequested} = agentStates
        return [createRequested, launchRequested].includes(agentState)
      },

      isVisible() {
        const agentState = this.channel.rbm.agent_state
        const {new: newState, createRequested, created} = agentStates
        return [newState, createRequested, created].includes(agentState)
      },

      clearPromise() {
        this.promiseButtonClicked = null
      },

      handleClick() {
        const agentState = this.channel.rbm.agent_state

        if (agentState === agentStates.new) {
          this.$root.$emit('bv::show::modal', this.modalIdCreateAgent)
          return Promise.resolve()
            .then(this.clearPromise)
        }

        if (agentState === agentStates.created) {
          return channelService.patch(this.channel.id, {
            rbm: {
              agent_state: agentStates.launchRequested
            }
          })
            .then(response => {
              eventBus.$emit('update-channel', response.data)
            })
            .catch(error => {
              if (error.response.status !== 422) return

              log.debug('RBM agent update failed with error:', error)
              this.errors = error.response.data.errors
            })
            .then(this.clearPromise)
        }

        return Promise.resolve()
          .then(this.clearPromise)
      }

    }
  }
</script>
